// ModalResendInvoice.jsx
import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { postWithAuth } from "../../api/api";
import { API_URLS } from "../../api/apiConfig";
import { useInvoicing } from "../invoiceContext";

const ModalResendInvoice = ({ onClose, invoice }) => {
  const invoicingContext = useInvoicing();
  const [isLoading, setIsLoading] = useState(false);
  const [localError, setLocalError] = useState("");

  if (!invoice) return null;

  const handleResend = async () => {
    setIsLoading(true);
    setLocalError("");

    try {
      // Ajusta el endpoint al que tengas definido
      const response = await postWithAuth(
        API_URLS.RESEND_INVOICE(invoice.id),
        {}
      );

      if (response.message === "success") {
        invoicingContext.setAlertType("success");
        invoicingContext.setMessage("Factura reenviada correctamente");
        invoicingContext.openAlertHeader();
        invoicingContext.changeApiSuccess(); // si quieres refrescar algo
        onClose();
      } else {
        setLocalError(response.detail || "Ha ocurrido un error al reenviar");
      }
    } catch (error) {
      console.error("Error reenviando factura:", error);
      setLocalError("Ha ocurrido un error al reenviar");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal show={true} onHide={onClose} size="md" centered>
      <Modal.Header closeButton>
        <Modal.Title>Reenviar factura</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          ¿Seguro que quieres reenviar la factura{" "}
          <strong>{invoice.invoice_number}</strong> (EntryID{" "}
          <strong>{invoice.entry_id}</strong>)?
        </p>
        {localError && (
          <div className="alert alert-danger mt-3">{localError}</div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onClose}>
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={handleResend}
          disabled={isLoading}
          data-kt-indicator={isLoading ? "on" : "off"}
        >
          <span className="indicator-label">Reenviar factura</span>
          <span className="indicator-progress">
            Reenviando...
            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
          </span>
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalResendInvoice;
